import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"ma-0 pa-0",attrs:{"fill-height":""}},[(!_vm.token)?_c('RequestPasswordReset'):_vm._e(),(_vm.token)?_c('ResetPassword',{attrs:{"token":_vm.token}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }